<template>
    <div>
        <svg
            width="100%"
            height="100%"
            viewBox="0 0 1024 683"
            xmlns="http://www.w3.org/2000/svg"
            @click="modalOpen = true"
        >
            <rect
                width="100%"
                height="100%"
                :fill="backgroundColor"
                rx="15"
                ry="15"
            />

            <!-- Header Labels -->
            <g font-size="25" font-weight="bold" :fill="fontColor">
                <text x="89" y="71">MÅN</text>
                <text x="216" y="71">TIS</text>
                <text x="343" y="71">ONS</text>
                <text x="470" y="71">TOR</text>
                <text x="597" y="71">FRE</text>
                <text x="724" y="71">LÖR</text>
                <text x="851" y="71">SÖN</text>
            </g>

            <!-- Days Grid -->
            <g font-size="25" font-weight="bold">
                <!-- Row 1 -->
                <text x="497" y="156" :fill="fontColor">1</text>
                <text x="624" y="156" :fill="fontColor">2</text>
                <text x="751" y="156" fill="#B0A7B7">3</text>
                <text x="878" y="156" fill="#B0A7B7">4</text>

                <!-- Row 2 -->
                <text x="114" y="270" :fill="fontColor">5</text>
                <text x="241" y="270" :fill="fontColor">6</text>
                <text x="368" y="270" :fill="fontColor">7</text>
                <text x="495" y="270" :fill="fontColor">8</text>
                <text x="622" y="270" :fill="fontColor">9</text>
                <text x="749" y="270" fill="#B0A7B7">10</text>
                <text x="876" y="270" fill="#B0A7B7">11</text>

                <!-- Row 3 -->
                <text x="114" y="384" :fill="fontColor">12</text>
                <text x="241" y="384" :fill="fontColor">13</text>
                <text x="368" y="384" :fill="fontColor">14</text>
                <text x="495" y="384" :fill="fontColor">15</text>
                <text x="622" y="384" :fill="fontColor">16</text>
                <text x="749" y="384" fill="#B0A7B7">17</text>
                <text x="876" y="384" fill="#B0A7B7">18</text>

                <!-- Row 4 -->
                <text x="114" y="498" :fill="fontColor">19</text>
                <text x="241" y="498" :fill="fontColor">20</text>
                <text x="368" y="498" :fill="fontColor">21</text>
                <text x="495" y="498" :fill="fontColor">22</text>
                <text x="622" y="498" :fill="fontColor">23</text>
                <text x="749" y="498" fill="#B0A7B7">24</text>
                <text x="876" y="498" fill="#B0A7B7">25</text>

                <!-- Row 5 -->
                <text x="114" y="612" :fill="fontColor">26</text>
                <text x="241" y="612" :fill="fontColor">27</text>
                <text x="368" y="612" :fill="fontColor">28</text>
                <text x="495" y="612" :fill="fontColor">29</text>
                <text x="622" y="612" :fill="fontColor">30</text>
                <text x="749" y="612" fill="#B0A7B7">31</text>
            </g>

            <!-- Decorative Circle with Image Placeholder -->
            <g v-if="showSellerImage && sellerImageUrl">
                <circle cx="878" cy="534" r="113" fill="#FFFFFF" />
                <clipPath id="imgClip">
                    <circle cx="878" cy="534" r="110" />
                </clipPath>
                <image
                    :href="sellerImageUrl"
                    x="761"
                    y="411"
                    width="234"
                    height="234"
                    clip-path="url(#imgClip)"
                    preserveAspectRatio="xMidYMid slice"
                />
            </g>
        </svg>
        <div class="pl-3 pt-2">
            <div class="text-uppercase" style="font-size: 15px">Kalender</div>
            <div class="font-weight-bold" style="font-size: 20px">
                {{ title }}
            </div>
        </div>
        <sb-modal
            centered
            hide-footer
            title="Mötesförfrågan"
            v-model="modalOpen"
        >
            <p v-if="meetingRequested">Tack för din förfrågan!</p>
            <axios-form
                v-else
                method="post"
                :action="route('meetingRequests.store', quoteKey)"
                @success="meetingRequested = true"
            >
                <p>Skicka ett förslag på tid nedan, så återkommer vi:</p>
                <textarea
                    name="message"
                    required
                    class="form-control w-100"
                ></textarea>
                <button
                    type="submit"
                    class="btn signbuttoninline mt-3 d-block mx-auto"
                >
                    <i class="fa-regular fa-paper-plane mr-1"></i> Skicka
                    mötesförfrågan
                </button>
            </axios-form>
        </sb-modal>
    </div>
</template>

<style lang="scss" scoped>
a {
    display: block;
    width: 100%;

    img {
        width: 100%;
        height: auto;
        border-top-left-radius: 5px;
        border-top-right-radius: 5px;
        border-bottom-right-radius: 5px;
        border-bottom-left-radius: 5px;
    }

    p {
        margin-top: 8px;
        margin-bottom: 0px;
        text-align: center;
        text-decoration: none;
        color: black;
    }
}
</style>

<script setup lang="ts">
import { ref } from "vue";
import SbModal from "../sb/SbModal.vue";

interface Props {
    quoteKey: string;
    showSellerImage?: boolean;
    sellerImageUrl?: string | null;
    backgroundColor: string;
    fontColor: string;
    title: string;
}

withDefaults(defineProps<Props>(), {
    showSellerImage: true,
    sellerImageUrl: null,
});
const modalOpen = ref(false);
const meetingRequested = ref(false);
</script>
